<script>
export const group = 'Bottom'
</script>

<script setup>
import TextSlideUp from './text_animations/TextSlideUp.vue'
import StopwatchBlocks from './shared/StopwatchBlocks.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const timelineTitleAbove = ref(null)
const timelineTitleAboveOut = ref(null)
const timelineTitleBelow = ref(null)
const timelineTitleBelowOut = ref(null)
const timelineStopwatch = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Stopwatch' }).add(timelineTitleAbove).add(timelineStopwatch).add(timelineTitleBelow, '-=0.48')
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineStopwatch.value.reverse()

  await gsapTimeline({ name: 'StopwatchSmall - End' }).add(timelineTitleBelowOut.value(), '<').add(timelineTitleAboveOut.value(), '<').add(timelineStopwatch, '<')
})
</script>

<template>
  <div class="absolute bottom-0 p-safe z-10 w-full">
    <div class="text-white space-y-6 flex flex-col items-start">
      <TextSlideUp :text="item.properties.titleAbove || ''" class="text-[6rem] font-bold leading-none" @timeline="timelineTitleAbove = $event" @timelineOut="timelineTitleAboveOut = $event" />
      <StopwatchBlocks :stopwatch="item.enrichment.stopwatch" :showDays="!item.properties.showDaysAsHours" small @timeline="timelineStopwatch = $event" />
      <TextSlideUp :text="item.properties.titleBelow || ''" class="text-[6rem] font-bold leading-none" @timeline="timelineTitleBelow = $event" @timelineOut="timelineTitleBelowOut = $event" />
    </div>
  </div>
</template>
